import { render, staticRenderFns } from "./SellerCallLogs.vue?vue&type=template&id=e890139e&scoped=true"
import script from "./SellerCallLogs.vue?vue&type=script&lang=js"
export * from "./SellerCallLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e890139e",
  null
  
)

export default component.exports